<template>
  

  <div>
    <b-row class="my-1 align-items-center">
      <b-col class="col-2">
        <label for="" class="mr-1">Escala artrosis:</label>
      </b-col>

      <b-col class="col-8">
        <b-input-group :append="escalas.artrosis">
          <b-form-input
            type="range"
            min="0"
            max="5"
            v-model="escalas.artrosis"
          />
        </b-input-group>
        
      </b-col>

      <b-col class="col-2">
        <span v-if="escalas.artrosis == 5" style="color: red"> Severo </span>
      </b-col>
    </b-row>

    <b-row class="my-1 align-items-center">
      <b-col class="col-2">
        <label for="" class="mr-1">Escala muscular (Daniels):</label>
      </b-col>

      <b-col class="col-8">
        <b-input-group :append="escalas.muscular">
          <b-form-input
            type="range"
            min=0
            max=5
            v-model="escalas.muscular"
          />
        </b-input-group>      
      </b-col>

      <span v-if="escalas.muscular == 5" style="color: red"> Severo </span>
    </b-row>
  </div>
  
</template>

<script>
export default {

  name: "EscalasFisiatricas",

  data() {
    return {
      escalas:{
        artrosis: "0",
        muscular: "0",
      }
    };
  },

  watch: {
    escalas: {
      handler(newValue) {
        this.$store.commit("setFisiatriaEscalas", newValue);
      },
      deep: true,
    },
  },
  
}
</script>